/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useAgent} from '#/state/session'
import {Button, ButtonText} from '#/components/Button'
import {BodyText, Heading} from '#/wsocial/components/primitives'
import {BackButton, PageShell, SupportFooter} from './primitives'
import {QrSessionBlock} from './QrSessionBlock'

export function StepWidSetup({
  onBack,
  onSkip,
}: {
  onBack?: () => void
  onSkip?: () => void
}) {
  const agent = useAgent()

  return (
    <PageShell>
      <div className="SignUpQrCenter">
        <QrSessionBlock
          size={300}
          queryKey="wid-setup-a"
          initFn={signal => agent.quicklogin.allocateWidForAccount({signal})}
        />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>Verify your account</Heading>
        <BodyText>
          Scan the code and complete the verification in W Identity.
        </BodyText>
      </div>

      <div
        style={{
          padding: '16px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
        }}>
        {onBack && <BackButton onPress={onBack} />}
        {onSkip && (
          <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
            <Button
              label="Explore W without verifying"
              color="secondary"
              size="large"
              testID="skipBtn"
              onPress={onSkip}>
              <ButtonText>Explore W without verifying</ButtonText>
            </Button>
          </div>
        )}
      </div>

      <SupportFooter />
    </PageShell>
  )
}
